<template>
    <filters-expansion>
        <v-row>
            <v-col cols="12" md="4" class="d-flex justify-center">
                <v-autocomplete
                    v-model="activeFilters.id"
                    :label="id.label"
                    :items="id.valuesData"
                    hide-no-data
                    cache-items
                    clearable
                    multiple
                    item-text="id"
                    item-value="id"
                    color="teal lighten-2"
                    item-color="teal lighten-2"
                    @change="filterChange"
                ></v-autocomplete>
            </v-col>
            <v-col cols="12" md="4" class="d-flex justify-center">
                <v-autocomplete
                    v-model="activeFilters.name"
                    :label="name.label"
                    :items="name.valuesData"
                    hide-no-data
                    cache-items
                    clearable
                    multiple
                    item-text="name"
                    item-value="id"
                    color="teal lighten-2"
                    item-color="teal lighten-2"
                    @change="filterChange"
                ></v-autocomplete>
            </v-col>
            <v-col cols="12" md="4" class="d-flex justify-center">
                <v-autocomplete
                    v-model="activeFilters.email"
                    :label="email.label"
                    :items="email.valuesData"
                    hide-no-data
                    cache-items
                    clearable
                    multiple
                    item-text="email"
                    item-value="email"
                    color="teal lighten-2"
                    item-color="teal lighten-2"
                    @change="filterChange"
                ></v-autocomplete>
            </v-col>
            <v-col cols="12" md="4" class="d-flex justify-center">
                <v-autocomplete
                    v-model="activeFilters.phone"
                    :label="phone.label"
                    :items="phone.valuesData"
                    hide-no-data
                    cache-items
                    clearable
                    multiple
                    item-text="phone"
                    item-value="phone"
                    color="teal lighten-2"
                    item-color="teal lighten-2"
                    @change="filterChange"
                ></v-autocomplete>
            </v-col>
            <v-col cols="12" md="4" class="d-flex justify-center">
                <v-menu
                    ref="menu"
                    v-model="datePkr"
                    :close-on-content-click="false"
                    :return-value.sync="activeFilters.createdAt"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                >
                    <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                            v-model="formattedDate"
                            :label="createdAt.label"
                            clearable
                            v-bind="attrs"
                            v-on="on"
                            color="teal lighten-2"
                        ></v-text-field>
                    </template>
                    <v-date-picker
                        v-model="activeFilters.createdAt"
                        color="teal lighten-2"
                        no-title
                        range
                    >
                        <v-spacer></v-spacer>
                        <v-btn
                            text
                            color="teal lighten-2"
                            @click="datePkr = false"
                        >
                            {{ $t('close') }}
                        </v-btn>
                        <v-btn
                            text
                            color="teal lighten-2"
                            @click="dateChange(activeFilters.createdAt)"
                        >
                            {{ $t('set') }}
                        </v-btn>
                    </v-date-picker>
                </v-menu>
            </v-col>
            <v-col cols="12" md="4" class="d-flex justify-center">
                <v-text-field
                    v-model.trim="search"
                    :label="$t('siteSearch')"
                    single-line
                    hide-details
                    clearable
                    color="teal lighten-2"
                    append-icon="mdi-magnify"
                ></v-text-field>
            </v-col>
        </v-row>
    </filters-expansion>
</template>

<script>
    import { debounce } from 'lodash';
    import filterService from '../../services/api/FilterService';
    import { MixinUsersGeneral } from '../../mixins';
    import FiltersExpansion from './FiltersExpansion';

    export default {
        name: 'UsersFilters',
        components: { FiltersExpansion },
        mixins: [MixinUsersGeneral],
        props: {
            usersType: {
                required: false,
                type: Number,
                default: null,
            },
        },
        data() {
            return {
                activeFilters: {},
                search: '',
                layout: [],
                datePkr: false,
            }
        },
        computed: {
            id() {
                return this.findLayout('id');
            },
            createdAt() {
                return this.findLayout('createdAt');
            },
            email() {
                return this.findLayout('email');
            },
            name() {
                return this.findLayout('name');
            },
            phone() {
                return this.findLayout('phone');
            },
            formattedDate: {
                get() {
                    return Array.isArray(this.activeFilters.createdAt)
                        ? this.activeFilters.createdAt
                            .sort()
                            .map(date => new Date(date).toLocaleDateString())
                            .join(' - ')
                        : '';
                },
                set(newVal) {
                    this.activeFilters.createdAt = newVal;
                    this.filterChange();
                },
            },
        },
        methods: {
            dateChange(date) {
                this.$refs.menu.save(date);
                this.filterChange();
            },
            findLayout(name) {
                return this.layout.find(item => item.systemName === this.usersFilters[name].systemName) || {};
            },
            getLayout() {
                filterService.setLocale(this.$store.getters.appLanguage);
                filterService.getUsersLayout({ usersType: this.usersType })
                    .then(res => {
                        this.layout = res.data;
                        this.setFiltersFromUrl();
                    })
                    .catch(console.log)
            },
            filterChange() {
                this.addFiltersToUrl(this.activeFilters, this.$route);
                this.$emit('filter-change', { ...this.activeFilters });
            },
            setFiltersFromUrl() {
                this.activeFilters = this.getFiltersFromUrl();
                this.filterChange();
            },
        },
        created() {
            this.getLayout();
        },
        watch: {
            search: debounce(function(value) {
                if (value) {
                    this.activeFilters.search = value;
                } else {
                    delete this.activeFilters.search;
                }

                this.filterChange();
            }, 500),
            'activeFilters.search'(value) {
                this.search = value;
            }
        },
    };
</script>

<style scoped>

</style>
